import React from 'react'
import Image from 'next/image'
import {useStateContext} from '../context/StateContext';
import { urlFor } from '../lib/client';
import {RegisterHeaderField, TitleWithIcon, UserIcon, VisDiv} from '../components';

const DesktopRegisterHeader = ({headerData, pdfButton, registerNonConformities}) => {

    const {
        customer,
        client,
        site,
        register,
        sUser,
        currentTemplate,
        LDB
    } = useStateContext(); 
    const P = "registerHeader"

const plessoTitle = () => {

    return "PLESSO: "
}

  const clientName = () => {
    if(!headerData?.notComune) return `COMUNE DI ${headerData?.client}`
    return headerData?.client
  }

  return (
    <div className='desktop-header'>
        <div className='dskh-siteinfo'>
            <div className='side'>
            {   
                headerData.customerSignature && <img
                        style={{width:"142px", height:"70px", marginLeft:"52px"}}
                        src={headerData.customerSignature}
                        
                    /> } 

            </div>
            <div className='center'>            
                <img 
                src={headerData?.customerLogo}
                style={{width:`${headerData?.customerLogoWidth}px`, height:`${headerData?.customerLogoHeight}px`}}
                />
            </div>
            <div className='right-side'><VisDiv rules={[sUser?.language !== "en"]} >{pdfButton}</VisDiv></div>
        </div>
        <div className='dskh-siteinfo'>
            <div className='side'><RegisterHeaderField title={LDB("misc","client")+": "} data={clientName()}/></div>
            <div className='center'><RegisterHeaderField title={""} data={headerData.site}/></div>
            <div className='right-side'><RegisterHeaderField title={LDB("misc","address")+": "} data={headerData.address1 + headerData.houseNumber + headerData.address2 + headerData.postcode + headerData.city}/></div>
        </div>
        <div className='dskh-siteinfo'>
            <div className='side'> 
                {registerNonConformities}
            </div>
            <div className='center-column'>
                {headerData?.registerIcon && (
                    <TitleWithIcon
                    icon={headerData.registerIcon}
                    title={headerData.register}
                    fontSize={"10px"}
                    iconSize={"2rem"}
                    />)}
                    <div style={{marginBottom:"10px"}}>
                        <h4>{headerData?.registerName}</h4>
                    </div>
                    <p>{headerData?.description}</p>
            </div>
     
            <div className='right-side'>
                {headerData?.lastCheck && <UserIcon
                    //sPicture={sUser.image}
                    bypassCurrentUser={true}
                    size={40}
                    name
                    dateText={LDB("device", "lastCheck")}
                    date={headerData.lastCheck}
                    otherUser={headerData.technician}                   
                /> } 
            </div>
        </div>
        <div className='dskh-notes'>{headerData.notes}</div>

    </div>
  )
}

export default DesktopRegisterHeader
